/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const html = document.querySelector('html');
  
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var defaultTo = function(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  // Footer newsletter form
  if (!customElements.get('newsletter-footer')) {
    class NewsletterFooter extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.heading = document.querySelector('.footer-newsletter__title');
        this.klaviyoListId = this.getAttribute('data-klaviyo-list-id');
        this.email = this.querySelector('input[type="email"]');
        if (this.klaviyoListId) {
          this.form.addEventListener('submit', this.sendForm.bind(this));
        } else {
          return console.error('Klaviyo form id not found.');
        }
      }

      formData() {
        return {
          g: this.klaviyoListId,
          '$fields': '$source,$email,$consent_method,$consent_form_id',
          '$list_fields': '',
          '$timezone_offset': Math.abs(new Date().getTimezoneOffset() / 60),
          '$source': 'Newsletter subscription',
          '$email': (this.querySelector('input[type="email"]')) ? this.querySelector('input[type="email"]').value : '',
          '$consent_method': 'Klaviyo Form',
          '$origin': 'origin'
        };
      }

      showMessage(type) {
        this.classList.add('hide');
        this.heading.classList.add('hide');
        document.querySelector('.footer-newsletter__' + type).classList.remove('hide');
      }

      sendForm(event) {
        event.preventDefault();
        const _this = this;

        fetch("https://a.klaviyo.com/ajax/subscriptions/subscribe", {
          "headers": {
            "accept": "*/*",
            "accept-language": "en-US,en;q=0.9",
            "content-type": "application/x-www-form-urlencoded",
          },
          "body": _this.objToStrUrlEncode(_this.formData()),
          "method": "POST",
          "mode": "cors",
          "credentials": "omit"
        }).then(response => response.json())
          .then(response => {
            console.log(response)
            if (response.success) {
              (response.data.is_subscribed) ? _this.showMessage('is-subscribed') : _this.showMessage('success');
            } else {
              _this.showMessage('error');
            }
          })
          .catch(err => {
            console.log(err)
            _this.showMessage('error');
          });
      }

      objToStrUrlEncode(obj) {
        const str = [];
        for (let key in obj) {
          if (obj.hasOwnProperty(key) && typeof obj[key] !== 'undefined') {
            str.push(encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
          }
        }
        return str.join('&')
      }
    }

    customElements.define('newsletter-footer', NewsletterFooter);
  }

  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('[id^="Deferred-Poster-"]');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }

    loadContent() {
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

        this.setAttribute('loaded', 'true');
        this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
        if (this.querySelector('video')) this.querySelector('video').play()
      }
    }
  }

  customElements.define('deferred-media', DeferredMedia);

  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.html = document.querySelector('html');
      this.showOptionsBtn = this.querySelector('[data-show-options]');
      this.quickAddBtn = this.querySelector('[data-quick-add]');
      this.formWrapper = this.querySelector('.product-card__form-wrapper');
      this.optionSelect = this.querySelectorAll('select');
      this.formInput = this.querySelector('input[name="id"]');
      this.errorMessage = this.querySelector('[data-error-message]');
      this.productUrl = this.querySelectorAll('.product-link');
      this.variantDiscount = this.querySelector('.product-card__discount');

      if (this.showOptionsBtn) {
        this.showOptionsBtn.addEventListener('click', this.showOptions.bind(this));
      }

      if (this.quickAddBtn) {
        this.quickAddBtn.addEventListener('click', this.addToCart.bind(this));
      }

      this.optionSelect.forEach((elem) => elem.addEventListener('change', this.onVariantChange.bind(this)));
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.updateBtn();

      if (this.currentVariant) {
        this.updateVariantInput();
        this.updateUrl();
        this.updatePrice();
        this.checkVariantDiscount();
      } else {
        this.hideOptions();
        this.updateBtn();
      }
    }

    showOptions() {
      this.showAddBtn();
      this.formWrapper.classList.add('is-visible');
    }

    hideOptions() {
      this.formWrapper.classList.remove('is-visible');
    }

    addToCart() {
      this.html.dispatchEvent(
        new CustomEvent('cart:add-to-cart', {
          bubbles: true,
          detail: {
            element: this.querySelector('[data-quick-add-holder]'),
            errorMessage: this.errorMessage,
            customCard: true,
            data: {
              id: this.getCurrentVariantId(),
              quantity: 1,
            },
          },
        })
      );
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('.product-card__option-select'), (select) => select.value);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    getCurrentVariantId() {
       return parseInt(this.querySelector('input[name="id"]').value)
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    updateVariantInput() {
      this.formInput.value = this.currentVariant.id;
    }

    checkVariantDiscount() {
      const saleOption = this.currentVariant.options.find((option) => {
        let optionLowercase = option.toLowerCase();
        if (optionLowercase.includes('save')) return true;
      })

      let saleOptionText;
      if (saleOption) {
        saleOptionText = saleOption.split('/')[1].replace('oz', 'pound');
      }

      if (this.currentVariant.compare_at_price && saleOptionText && this.variantDiscount && saleOption) {
        this.variantDiscount.classList.remove('hide');
        this.variantDiscount.innerHTML = saleOptionText.toLowerCase();
      } else {
        this.variantDiscount.classList.add('hide');
      }
    }

    updateBtn() {
      const btnAvailableText = this.quickAddBtn.querySelector('.available');
      const btnSoldOutText = this.quickAddBtn.querySelector('.sold-out');

      this.quickAddBtn.classList.remove('is-added');
      if (this.currentVariant && this.currentVariant.available) {
        this.quickAddBtn.removeAttribute('disabled');
        btnAvailableText.classList.remove('hide');
        btnSoldOutText.classList.add('hide');
      } else {
        btnAvailableText.classList.add('hide');
        btnSoldOutText.classList.remove('hide');
        this.quickAddBtn.setAttribute('disabled', 'disabled');
      }
    }

    showAddBtn() {
      this.quickAddBtn.classList.remove('hide');
      this.showOptionsBtn.classList.add('hide');
    }

    hideAddBtn() {
      this.quickAddBtn.classList.add('hide');
      this.showOptionsBtn.classList.remove('hide');
    }

    updateUrl() {
      this.productUrl.forEach((link) => {
        const currentUrl = this.getAttribute('data-url');
        const newUrl = currentUrl + '?variant=' + this.currentVariant.id
          link.setAttribute('href', newUrl);
      })
    }

    updatePrice() {
      const price = this.querySelector('.new-price');
      const oldPrice = this.querySelector('.old-price');
      const variantPrice = formatMoney(this.currentVariant.price, '${{amount}}');

      price.innerHTML = variantPrice ? variantPrice : '';

      if (this.currentVariant.compare_at_price) {
        const variantCompareAtPrice = formatMoney(this.currentVariant.compare_at_price, '${{amount}}');

        oldPrice.classList.remove('hide');
        oldPrice.innerHTML = variantCompareAtPrice ? variantCompareAtPrice : ''
      } else {
        oldPrice.classList.add('hide');
        oldPrice.innerHTML = '';
      }
    }
  }

  customElements.define('product-card', ProductCard);

  const upsellProductCardSelectors = {
    button: '[data-upsell-add]',
    subscriptionSelect: '[data-upsell-selling-plan-select]',
  }

  class UpsellProductCard extends HTMLElement {
    constructor() {
      super();
      // Assign instance variables
      this.button = this.querySelector(upsellProductCardSelectors.button);
      this.sellingPlanSelect = this.querySelector(upsellProductCardSelectors.subscriptionSelect);
      this.sellingPlanId = this.button?.dataset.sellingPlanId;
      this.sellingPlanGroup = this.button?.dataset.sellingPlanGroup;
      // Attach events
      this.onClickAddToCart();
      this.updateSellingPlanOnSelect();
    }
  
    onClickAddToCart() {
      this.button?.addEventListener('click', () => {
        const element = this.button;
        const data = {
              'id': parseInt(this.button.getAttribute('data-variant-id')),
              quantity: 1
            }

        if(this.sellingPlanId) {
          data.selling_plan_group = this.sellingPlanGroup
          data.selling_plan = parseInt(this.sellingPlanId)
        }

        html.dispatchEvent(
          new CustomEvent('cart:add-to-cart', {
            bubbles: true,
            detail: {
              element,
              data,
            },
          }),
        );
      });
    }
  
    updateSellingPlanOnSelect() {
      this.sellingPlanSelect?.addEventListener('change', () => {
        const [option] = this.sellingPlanSelect.selectedOptions;
        const { value } = option;
        if (value) {
          this.updateSellingPlan(value);
          this.updateSellingPlanAttribute();
        }
      });
    }
  
    updateSellingPlanAttribute() {
      this.button.dataset.sellingPlanId = this.sellingPlanId;
    }
  
    updateSellingPlan(value) {
      this.sellingPlanId = value;
    }
  
  }

  customElements.define('upsell-product-card', UpsellProductCard);

  class CartUpsell extends HTMLElement {
    constructor() {
      super();
      this.html = document.querySelector('html');
      this.upsellAdd = this.querySelectorAll('[data-upsell-add]')
      this.content = this.querySelector('[data-upsell-content]')
      this.recentlyViewedProducts = false
      this.productsToShow = this.content.dataset.limit
      this.showRecentlyViewed = this.content.dataset.recently

      if (this.showRecentlyViewed === 'true') {
        this.getRecentlyViewedProducts()
      }
    }

    getRecentlyViewedProducts() {
      if (document.cookie.indexOf('; ') !== -1 && document.cookie.split('; ').find((row) => row.startsWith('shopify_recently_viewed'))) {
        this.recentlyViewedProducts = document.cookie
            .split('; ')
            .find((row) => row.startsWith('shopify_recently_viewed'))
            .split('=')[1]
            .split(' ');
      }
      (this.recentlyViewedProducts.length) ? this.checkRecentlyViewedInCart() : this.classList.remove('show-skeleton');
    }

    checkRecentlyViewedInCart() {
      fetch(theme.routes.root + 'cart.js')
          .then((response) => response.json())
          .then((response) => {
            if (!response.items.length) return
            const cartHandles = response.items.reduce((all, item) => all.concat(item.handle), []);
            this.recentlyViewedProducts = this.recentlyViewedProducts.filter(handle => !cartHandles.includes(handle));
          })
          .then(() => {
            (this.recentlyViewedProducts.length) ? this.getRecentlyViewedContent() : this.classList.remove('show-skeleton');
          })
          .catch((error) => {
            console.log(error)
            this.classList.remove('show-skeleton')
          });
    }

    getRecentlyViewedContent() {
      this.recentlyViewedProducts = this.recentlyViewedProducts.splice(0, this.productsToShow);
      Promise.all(this.recentlyViewedProducts.map(handle => {
        return fetch('/products/' + handle + '?section_id=api-product-upsell-item').then((response) => response.text())
      })).then(values => {
        const content = values.map(item => {
          return new DOMParser()
              .parseFromString(item.toString(), 'text/html')
              .querySelector('.product-upsell-card').outerHTML
        })
        this.buildContent(content)
      }).catch((error) => {
        console.log(error)
        this.showSection()
      });
    }

    buildContent(content) {
      const upsellHtml = this.content.innerHTML;
      this.content.innerHTML = content.join('') + upsellHtml
      this.content.querySelectorAll('.product-upsell-card').forEach((card, i) => {
        if (i >= this.productsToShow) this.content.removeChild(card);
      })
      this.showSection()
    }

    showSection() {
      this.classList.remove('show-skeleton')
      this.classList.remove('hide')
    }
  }

  customElements.define('cart-upsell', CartUpsell);


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();


